import { render, staticRenderFns } from "./AmenitiesOption.vue?vue&type=template&id=130911ca&scoped=true&"
import script from "./AmenitiesOption.vue?vue&type=script&lang=js&"
export * from "./AmenitiesOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130911ca",
  null
  
)

export default component.exports